import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import ShipperSettings from 'components/modules/user/shipper/ShipperSettings';
import StopDocumentRequirements from 'components/modules/user/shipper/StopDocumentRequirements';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
const StopDocumentRequirementsPage = () => {
    const { t } = useTranslation();
    const params = useParams();
    const id = params.id;
    const [user, setUser] = useState();
    async function fetchUser() {
        const user = await getCustomerV2(id);
        setUser(user);
    }
    useEffect(() => {
        fetchUser();
    }, []);
    function renderSidebar() {
        return (React.createElement(ShipperSettings, { activePage: "stop-document-requirements", userId: id }));
    }
    const breadcrumbs = {
        pages: [
            {
                name: (user === null || user === void 0 ? void 0 : user.company_name) || t('SHIPPER'),
                href: `/users/${id}`,
                current: false,
            },
            {
                name: t('STOP_DOCUMENT_REQUIREMENTS'),
                href: `/users/${id}/settings/stop-document-requirements`,
                current: true,
            },
        ],
    };
    // TODO: REMOVE AccessorialRequests
    return (React.createElement(LayoutWithSidebar, { title: t('STOP_DOCUMENT_REQUIREMENTS'), sidebar: renderSidebar, breadcrumbs: breadcrumbs, className: "py-4" },
        React.createElement("div", { className: "w-full" }, featureEnabled(CONFIGURED_FEATURES.SSR) && (React.createElement(StopDocumentRequirements, { id: id })))));
};
export default StopDocumentRequirementsPage;
